module.exports = __webpack_public_path__ + "img/easion_logo_temp.75400d80.svg";